import { Modal } from "./Modal";
import type { ModalProps } from "./Modal.d";

export { Modal };
export type { ModalProps };
